import HalamanDepan from "../components/HalamanDepan/Home";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <HalamanDepan/>
    </div>
  );
}
